// extracted by mini-css-extract-plugin
export var author = "styles-module--author--4CdQx";
export var name = "styles-module--name--Jw4KV";
export var bio = "styles-module--bio--x-2N-";
export var publish = "styles-module--publish--IX0ES";
export var publishInfo = "styles-module--publishInfo--qPhqb";